import React from "react";

import { FaStop } from "react-icons/fa6";

const StopIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    const Icon = FaStop as any;

    return (
        <Icon color="white" size={17} {...props} />
    )
}

export default StopIcon;